window.MinestoneAccessoryCatalog = {
  "styles": [
    "Running Rings",
    "Stopper Beads",
    "Spacer Rings",
    "Statement Beads",
    "Floral & Symbols",
    "Colour Accents"
  ],
  "mappingByImage": {
    "running-ring-001.png": {
      "itemId": "RUNNING-RING-001",
      "styleCategory": "Running Rings",
      "displayOrder": 1,
      "verifiedName": "天然冰种天河石7颗圆珠跑环"
    },
    "running-ring-002.png": {
      "itemId": "RUNNING-RING-002",
      "styleCategory": "Running Rings",
      "displayOrder": 2,
      "verifiedName": "5A天然橙月光石"
    },
    "running-ring-003.png": {
      "itemId": "RUNNING-RING-003",
      "styleCategory": "Running Rings",
      "displayOrder": 3,
      "verifiedName": "天然粉晶"
    },
    "running-ring-004.png": {
      "itemId": "RUNNING-RING-004",
      "styleCategory": "Running Rings",
      "displayOrder": 4,
      "verifiedName": "天然白色珍珠贝"
    },
    "running-ring-005.png": {
      "itemId": "RUNNING-RING-005",
      "styleCategory": "Running Rings",
      "displayOrder": 5,
      "verifiedName": "5A天然紫水晶"
    },
    "running-ring-006.png": {
      "itemId": "RUNNING-RING-006",
      "styleCategory": "Running Rings",
      "displayOrder": 6,
      "verifiedName": "5A天然蓝月光石"
    },
    "running-ring-007.png": {
      "itemId": "RUNNING-RING-007",
      "styleCategory": "Running Rings",
      "displayOrder": 7,
      "verifiedName": "5A天然黄水晶"
    },
    "running-ring-008.png": {
      "itemId": "RUNNING-RING-008",
      "styleCategory": "Running Rings",
      "displayOrder": 8,
      "verifiedName": "7A天然灰月光石"
    },
    "running-ring-009.png": {
      "itemId": "RUNNING-RING-009",
      "styleCategory": "Running Rings",
      "displayOrder": 9,
      "verifiedName": "5A天然葡萄石"
    },
    "running-ring-010.png": {
      "itemId": "RUNNING-RING-010",
      "styleCategory": "Running Rings",
      "displayOrder": 10,
      "verifiedName": "7A天然白水晶"
    },
    "running-ring-011.png": {
      "itemId": "RUNNING-RING-011",
      "styleCategory": "Running Rings",
      "displayOrder": 11,
      "verifiedName": "7A天然茶水晶"
    },
    "running-ring-012.png": {
      "itemId": "RUNNING-RING-012",
      "styleCategory": "Running Rings",
      "displayOrder": 12,
      "verifiedName": "7A天然白玛瑙"
    },
    "running-ring-013.png": {
      "itemId": "RUNNING-RING-013",
      "styleCategory": "Running Rings",
      "displayOrder": 13,
      "verifiedName": "天然紫幽灵"
    },
    "running-ring-014.png": {
      "itemId": "RUNNING-RING-014",
      "styleCategory": "Running Rings",
      "displayOrder": 14,
      "verifiedName": "3A天然红胶花水晶"
    },
    "running-ring-015.png": {
      "itemId": "RUNNING-RING-015",
      "styleCategory": "Running Rings",
      "displayOrder": 15,
      "verifiedName": "7A天然冰种水草玛瑙"
    },
    "running-ring-016.png": {
      "itemId": "RUNNING-RING-016",
      "styleCategory": "Running Rings",
      "displayOrder": 16,
      "verifiedName": "5A天然水草玛瑙"
    },
    "running-ring-017.png": {
      "itemId": "RUNNING-RING-017",
      "styleCategory": "Running Rings",
      "displayOrder": 17,
      "verifiedName": "3A天然黑发晶"
    },
    "running-ring-018.png": {
      "itemId": "RUNNING-RING-018",
      "styleCategory": "Running Rings",
      "displayOrder": 18,
      "verifiedName": "白色猫眼石"
    },
    "running-ring-019.png": {
      "itemId": "RUNNING-RING-019",
      "styleCategory": "Running Rings",
      "displayOrder": 19,
      "verifiedName": "天然绿幽灵水晶"
    },
    "running-ring-020.png": {
      "itemId": "RUNNING-RING-020",
      "styleCategory": "Running Rings",
      "displayOrder": 20,
      "verifiedName": "7A天然海蓝宝"
    },
    "running-ring-021.png": {
      "itemId": "RUNNING-RING-021",
      "styleCategory": "Running Rings",
      "displayOrder": 21,
      "verifiedName": "3A天然萤石"
    },
    "running-ring-022.png": {
      "itemId": "RUNNING-RING-022",
      "styleCategory": "Running Rings",
      "displayOrder": 22,
      "verifiedName": "天然棉絮金发晶"
    },
    "running-ring-023.png": {
      "itemId": "RUNNING-RING-023",
      "styleCategory": "Running Rings",
      "displayOrder": 23,
      "verifiedName": "优化蓝松石"
    },
    "running-ring-024.png": {
      "itemId": "RUNNING-RING-024",
      "styleCategory": "Running Rings",
      "displayOrder": 24,
      "verifiedName": "7A红玛瑙"
    },
    "running-ring-025.png": {
      "itemId": "RUNNING-RING-025",
      "styleCategory": "Running Rings",
      "displayOrder": 25,
      "verifiedName": "5A天然青金石"
    },
    "running-ring-026.png": {
      "itemId": "RUNNING-RING-026",
      "styleCategory": "Running Rings",
      "displayOrder": 26,
      "verifiedName": "5A天然石榴石"
    },
    "running-ring-027.png": {
      "itemId": "RUNNING-RING-027",
      "styleCategory": "Running Rings",
      "displayOrder": 27,
      "verifiedName": "天然黑色条纹玛瑙"
    },
    "running-ring-028.png": {
      "itemId": "RUNNING-RING-028",
      "styleCategory": "Running Rings",
      "displayOrder": 28,
      "verifiedName": "天然粉晶圆珠流苏跑环"
    },
    "running-ring-029.png": {
      "itemId": "RUNNING-RING-029",
      "styleCategory": "Running Rings",
      "displayOrder": 29,
      "verifiedName": "3A天然草莓晶圆珠流苏跑环"
    },
    "running-ring-030.png": {
      "itemId": "RUNNING-RING-030",
      "styleCategory": "Running Rings",
      "displayOrder": 30,
      "verifiedName": "2A天然黄塔晶圆珠流苏跑环"
    },
    "running-ring-031.png": {
      "itemId": "RUNNING-RING-031",
      "styleCategory": "Running Rings",
      "displayOrder": 31,
      "verifiedName": "天然黄胶花水晶圆珠流苏跑环"
    },
    "running-ring-032.png": {
      "itemId": "RUNNING-RING-032",
      "styleCategory": "Running Rings",
      "displayOrder": 32,
      "verifiedName": "3A天然紫水晶圆珠流苏跑环"
    },
    "running-ring-033.png": {
      "itemId": "RUNNING-RING-033",
      "styleCategory": "Running Rings",
      "displayOrder": 33,
      "verifiedName": "5A天然白水晶圆珠流苏跑环"
    },
    "running-ring-034.png": {
      "itemId": "RUNNING-RING-034",
      "styleCategory": "Running Rings",
      "displayOrder": 34,
      "verifiedName": "5A天然白水晶铜隔圈圆珠跑环"
    },
    "running-ring-035.png": {
      "itemId": "RUNNING-RING-035",
      "styleCategory": "Running Rings",
      "displayOrder": 35,
      "verifiedName": "天然粉晶铜隔圈圆珠跑环"
    },
    "running-ring-036.png": {
      "itemId": "RUNNING-RING-036",
      "styleCategory": "Running Rings",
      "displayOrder": 36,
      "verifiedName": "3A天然紫水晶铜隔圈圆珠跑环"
    },
    "running-ring-037.png": {
      "itemId": "RUNNING-RING-037",
      "styleCategory": "Running Rings",
      "displayOrder": 37,
      "verifiedName": "5A天然草莓晶铜隔圈圆珠跑环"
    },
    "running-ring-038.png": {
      "itemId": "RUNNING-RING-038",
      "styleCategory": "Running Rings",
      "displayOrder": 38,
      "verifiedName": "1A天然黄塔晶铜隔圈圆珠跑环"
    },
    "running-ring-039.png": {
      "itemId": "RUNNING-RING-039",
      "styleCategory": "Running Rings",
      "displayOrder": 39,
      "verifiedName": "天然红绿宝8颗圆珠跑环"
    },
    "running-ring-040.png": {
      "itemId": "RUNNING-RING-040",
      "styleCategory": "Running Rings",
      "displayOrder": 40,
      "verifiedName": "天然深粉澳宝8颗圆珠跑环"
    },
    "running-ring-041.png": {
      "itemId": "RUNNING-RING-041",
      "styleCategory": "Running Rings",
      "displayOrder": 41,
      "verifiedName": "3A天然天河石8颗圆珠跑环"
    },
    "running-ring-042.png": {
      "itemId": "RUNNING-RING-042",
      "styleCategory": "Running Rings",
      "displayOrder": 42,
      "verifiedName": "天然梦幻海蓝宝8颗圆珠跑环"
    },
    "running-ring-043.png": {
      "itemId": "RUNNING-RING-043",
      "styleCategory": "Running Rings",
      "displayOrder": 43,
      "verifiedName": "天然黑金超七水晶8颗圆珠跑环"
    },
    "running-ring-044.png": {
      "itemId": "RUNNING-RING-044",
      "styleCategory": "Running Rings",
      "displayOrder": 44,
      "verifiedName": "3A天然白月光8颗圆珠跑环"
    },
    "running-ring-045.png": {
      "itemId": "RUNNING-RING-045",
      "styleCategory": "Running Rings",
      "displayOrder": 45,
      "verifiedName": "3A天然彩萤石8颗圆珠跑环"
    },
    "running-ring-046.png": {
      "itemId": "RUNNING-RING-046",
      "styleCategory": "Running Rings",
      "displayOrder": 46,
      "verifiedName": "7A天然茶水晶8颗圆珠跑环"
    },
    "running-ring-047.png": {
      "itemId": "RUNNING-RING-047",
      "styleCategory": "Running Rings",
      "displayOrder": 47,
      "verifiedName": "3A天然黑发晶8颗圆珠跑环"
    },
    "running-ring-048.png": {
      "itemId": "RUNNING-RING-048",
      "styleCategory": "Running Rings",
      "displayOrder": 48,
      "verifiedName": "天然冰透金发晶8颗圆珠跑环"
    },
    "running-ring-049.png": {
      "itemId": "RUNNING-RING-049",
      "styleCategory": "Running Rings",
      "displayOrder": 49,
      "verifiedName": "5A天然摩根石8颗圆珠跑环"
    },
    "running-ring-050.png": {
      "itemId": "RUNNING-RING-050",
      "styleCategory": "Running Rings",
      "displayOrder": 50,
      "verifiedName": "5A天然草莓晶8颗圆珠跑环"
    },
    "running-ring-051.png": {
      "itemId": "RUNNING-RING-051",
      "styleCategory": "Running Rings",
      "displayOrder": 51,
      "verifiedName": "天然红发晶8颗圆珠跑环"
    },
    "running-ring-052.png": {
      "itemId": "RUNNING-RING-052",
      "styleCategory": "Running Rings",
      "displayOrder": 52,
      "verifiedName": "天然绿萤石8颗圆珠跑环"
    },
    "running-ring-053.png": {
      "itemId": "RUNNING-RING-053",
      "styleCategory": "Running Rings",
      "displayOrder": 53,
      "verifiedName": "3A天然红胶花水晶8颗圆珠跑环"
    },
    "running-ring-054.png": {
      "itemId": "RUNNING-RING-054",
      "styleCategory": "Running Rings",
      "displayOrder": 54,
      "verifiedName": "5A天然梦幻紫水晶8颗圆珠跑环"
    },
    "running-ring-055.png": {
      "itemId": "RUNNING-RING-055",
      "styleCategory": "Running Rings",
      "displayOrder": 55,
      "verifiedName": "3A天然青金石8颗圆珠跑环"
    },
    "running-ring-056.png": {
      "itemId": "RUNNING-RING-056",
      "styleCategory": "Running Rings",
      "displayOrder": 56,
      "verifiedName": "3A天然冰种粉水晶8颗圆珠跑环"
    },
    "running-ring-057.png": {
      "itemId": "RUNNING-RING-057",
      "styleCategory": "Running Rings",
      "displayOrder": 57,
      "verifiedName": "5A天然葡萄石8颗圆珠跑环"
    },
    "running-ring-058.png": {
      "itemId": "RUNNING-RING-058",
      "styleCategory": "Running Rings",
      "displayOrder": 58,
      "verifiedName": "天然绿草莓晶8颗圆珠跑环"
    },
    "running-ring-059.png": {
      "itemId": "RUNNING-RING-059",
      "styleCategory": "Running Rings",
      "displayOrder": 59,
      "verifiedName": "3A天然白水晶8颗圆珠跑环"
    },
    "running-ring-060.png": {
      "itemId": "RUNNING-RING-060",
      "styleCategory": "Running Rings",
      "displayOrder": 60,
      "verifiedName": "7A天然白水晶8颗圆珠跑环"
    },
    "running-ring-061.png": {
      "itemId": "RUNNING-RING-061",
      "styleCategory": "Running Rings",
      "displayOrder": 61,
      "verifiedName": "5A天然金太阳石8颗圆珠跑环"
    },
    "running-ring-062.png": {
      "itemId": "RUNNING-RING-062",
      "styleCategory": "Running Rings",
      "displayOrder": 62,
      "verifiedName": "天然冰种天河石8颗圆珠跑环"
    },
    "diy-accessory-123.png": {
      "itemId": "ACC-123",
      "styleCategory": "Stopper Beads",
      "displayOrder": 63,
      "verifiedName": "#1508（硅胶珠）"
    },
    "diy-accessory-124.png": {
      "itemId": "ACC-124",
      "styleCategory": "Stopper Beads",
      "displayOrder": 64,
      "verifiedName": "#1509（硅胶珠）"
    },
    "diy-accessory-125.png": {
      "itemId": "ACC-125",
      "styleCategory": "Stopper Beads",
      "displayOrder": 65,
      "verifiedName": "#1510（硅胶珠）"
    },
    "diy-accessory-126.png": {
      "itemId": "ACC-126",
      "styleCategory": "Stopper Beads",
      "displayOrder": 66,
      "verifiedName": "#1511（硅胶珠）"
    },
    "diy-accessory-127.png": {
      "itemId": "ACC-127",
      "styleCategory": "Stopper Beads",
      "displayOrder": 67,
      "verifiedName": "#1512（硅胶珠）"
    },
    "diy-accessory-128.png": {
      "itemId": "ACC-128",
      "styleCategory": "Stopper Beads",
      "displayOrder": 68,
      "verifiedName": "#1513（硅胶珠）"
    },
    "diy-accessory-129.png": {
      "itemId": "ACC-129",
      "styleCategory": "Stopper Beads",
      "displayOrder": 69,
      "verifiedName": "#1514（硅胶珠）"
    },
    "diy-accessory-130.png": {
      "itemId": "ACC-130",
      "styleCategory": "Stopper Beads",
      "displayOrder": 70,
      "verifiedName": "#1515（硅胶珠）"
    },
    "diy-accessory-131.png": {
      "itemId": "ACC-131",
      "styleCategory": "Stopper Beads",
      "displayOrder": 71,
      "verifiedName": "#1516（硅胶珠）"
    },
    "diy-accessory-132.png": {
      "itemId": "ACC-132",
      "styleCategory": "Stopper Beads",
      "displayOrder": 72,
      "verifiedName": "#1517（硅胶珠）"
    },
    "diy-accessory-133.png": {
      "itemId": "ACC-133",
      "styleCategory": "Stopper Beads",
      "displayOrder": 73,
      "verifiedName": "#1518（硅胶珠）"
    },
    "diy-accessory-134.png": {
      "itemId": "ACC-134",
      "styleCategory": "Stopper Beads",
      "displayOrder": 74,
      "verifiedName": "#1519（硅胶珠）"
    },
    "diy-accessory-034.png": {
      "itemId": "ACC-034",
      "styleCategory": "Spacer Rings",
      "displayOrder": 75,
      "verifiedName": "款21锆石圈"
    },
    "diy-accessory-046.png": {
      "itemId": "ACC-046",
      "styleCategory": "Spacer Rings",
      "displayOrder": 76,
      "verifiedName": "款33齿轮锆石小号8mm"
    },
    "diy-accessory-047.png": {
      "itemId": "ACC-047",
      "styleCategory": "Spacer Rings",
      "displayOrder": 77,
      "verifiedName": "款34齿轮锆石大号10mm"
    },
    "diy-accessory-056.png": {
      "itemId": "ACC-056",
      "styleCategory": "Spacer Rings",
      "displayOrder": 78,
      "verifiedName": "款43方锆钻圈8mm"
    },
    "diy-accessory-067.png": {
      "itemId": "ACC-067",
      "styleCategory": "Spacer Rings",
      "displayOrder": 79,
      "verifiedName": "款54长方锆石车轮珠"
    },
    "diy-accessory-074.png": {
      "itemId": "ACC-074",
      "styleCategory": "Spacer Rings",
      "displayOrder": 80,
      "verifiedName": "款61车轮三排锆石隔珠"
    },
    "diy-accessory-098.png": {
      "itemId": "ACC-098",
      "styleCategory": "Spacer Rings",
      "displayOrder": 81,
      "verifiedName": "85水波槽纹圆形隔珠5mm"
    },
    "diy-accessory-103.png": {
      "itemId": "ACC-103",
      "styleCategory": "Spacer Rings",
      "displayOrder": 82,
      "verifiedName": "款90车轮隔片6mm"
    },
    "diy-accessory-112.png": {
      "itemId": "ACC-112",
      "styleCategory": "Spacer Rings",
      "displayOrder": 83,
      "verifiedName": "款101车轮隔珠3.3mm*8.1mm*5mm"
    },
    "diy-accessory-143.png": {
      "itemId": "ACC-143",
      "styleCategory": "Spacer Rings",
      "displayOrder": 84,
      "verifiedName": "#1528"
    },
    "diy-accessory-147.png": {
      "itemId": "ACC-147",
      "styleCategory": "Spacer Rings",
      "displayOrder": 85,
      "verifiedName": "#1532"
    },
    "diy-accessory-148.png": {
      "itemId": "ACC-148",
      "styleCategory": "Spacer Rings",
      "displayOrder": 86,
      "verifiedName": "#1533"
    },
    "diy-accessory-149.png": {
      "itemId": "ACC-149",
      "styleCategory": "Spacer Rings",
      "displayOrder": 87,
      "verifiedName": "#1534"
    },
    "diy-accessory-220.png": {
      "itemId": "ACC-220",
      "styleCategory": "Spacer Rings",
      "displayOrder": 88,
      "verifiedName": "#685"
    },
    "diy-accessory-227.png": {
      "itemId": "ACC-227",
      "styleCategory": "Spacer Rings",
      "displayOrder": 89,
      "verifiedName": "#1358"
    },
    "diy-accessory-263.png": {
      "itemId": "ACC-263",
      "styleCategory": "Spacer Rings",
      "displayOrder": 90,
      "verifiedName": "#1394"
    },
    "diy-accessory-264.png": {
      "itemId": "ACC-264",
      "styleCategory": "Spacer Rings",
      "displayOrder": 91,
      "verifiedName": "#1395"
    },
    "diy-accessory-032.png": {
      "itemId": "ACC-032",
      "styleCategory": "Statement Beads",
      "displayOrder": 92,
      "verifiedName": "款19微镶方形隔珠"
    },
    "diy-accessory-033.png": {
      "itemId": "ACC-033",
      "styleCategory": "Statement Beads",
      "displayOrder": 93,
      "verifiedName": "款20麻点锆石隔珠"
    },
    "diy-accessory-042.png": {
      "itemId": "ACC-042",
      "styleCategory": "Statement Beads",
      "displayOrder": 94,
      "verifiedName": "款29四方体锆石隔珠珠4.5*6mm小号"
    },
    "diy-accessory-043.png": {
      "itemId": "ACC-043",
      "styleCategory": "Statement Beads",
      "displayOrder": 95,
      "verifiedName": "款30四方体锆石隔珠珠7*5mm中号"
    },
    "diy-accessory-044.png": {
      "itemId": "ACC-044",
      "styleCategory": "Statement Beads",
      "displayOrder": 96,
      "verifiedName": "款31四方体锆石隔珠珠6*9mm大号"
    },
    "diy-accessory-054.png": {
      "itemId": "ACC-054",
      "styleCategory": "Statement Beads",
      "displayOrder": 97,
      "verifiedName": "款41镶蛋形锆大孔隔珠"
    },
    "diy-accessory-055.png": {
      "itemId": "ACC-055",
      "styleCategory": "Statement Beads",
      "displayOrder": 98,
      "verifiedName": "款42纤细六排小蛮腰"
    },
    "diy-accessory-058.png": {
      "itemId": "ACC-058",
      "styleCategory": "Statement Beads",
      "displayOrder": 99,
      "verifiedName": "款45圆筒齿轮5.5*6mm"
    },
    "diy-accessory-060.png": {
      "itemId": "ACC-060",
      "styleCategory": "Statement Beads",
      "displayOrder": 100,
      "verifiedName": "款47锆石镂空桶珠小号"
    },
    "diy-accessory-061.png": {
      "itemId": "ACC-061",
      "styleCategory": "Statement Beads",
      "displayOrder": 101,
      "verifiedName": "款48锆石镂空桶珠大号"
    },
    "diy-accessory-062.png": {
      "itemId": "ACC-062",
      "styleCategory": "Statement Beads",
      "displayOrder": 102,
      "verifiedName": "款49锆石小蛮腰小号"
    },
    "diy-accessory-063.png": {
      "itemId": "ACC-063",
      "styleCategory": "Statement Beads",
      "displayOrder": 103,
      "verifiedName": "款50锆石小蛮腰大号"
    },
    "diy-accessory-064.png": {
      "itemId": "ACC-064",
      "styleCategory": "Statement Beads",
      "displayOrder": 104,
      "verifiedName": "款51圆柱锆石"
    },
    "diy-accessory-065.png": {
      "itemId": "ACC-065",
      "styleCategory": "Statement Beads",
      "displayOrder": 105,
      "verifiedName": "款52石路路通隔珠"
    },
    "diy-accessory-068.png": {
      "itemId": "ACC-068",
      "styleCategory": "Statement Beads",
      "displayOrder": 106,
      "verifiedName": "款55金边小蛮腰"
    },
    "diy-accessory-071.png": {
      "itemId": "ACC-071",
      "styleCategory": "Statement Beads",
      "displayOrder": 107,
      "verifiedName": "款58镶锆齿轮隔珠"
    },
    "diy-accessory-073.png": {
      "itemId": "ACC-073",
      "styleCategory": "Statement Beads",
      "displayOrder": 108,
      "verifiedName": "款60大孔锆石隔珠"
    },
    "diy-accessory-077.png": {
      "itemId": "ACC-077",
      "styleCategory": "Statement Beads",
      "displayOrder": 109,
      "verifiedName": "款64小蛮腰锆石隔珠8*10mm"
    },
    "diy-accessory-080.png": {
      "itemId": "ACC-080",
      "styleCategory": "Statement Beads",
      "displayOrder": 110,
      "verifiedName": "款67镂空锆石球"
    },
    "diy-accessory-081.png": {
      "itemId": "ACC-081",
      "styleCategory": "Statement Beads",
      "displayOrder": 111,
      "verifiedName": "款68镶钻圆球8mm"
    },
    "diy-accessory-084.png": {
      "itemId": "ACC-084",
      "styleCategory": "Statement Beads",
      "displayOrder": 112,
      "verifiedName": "款71镂空锆石隔珠"
    },
    "diy-accessory-085.png": {
      "itemId": "ACC-085",
      "styleCategory": "Statement Beads",
      "displayOrder": 113,
      "verifiedName": "款72镂空锆石绣球10mm"
    },
    "diy-accessory-088.png": {
      "itemId": "ACC-088",
      "styleCategory": "Statement Beads",
      "displayOrder": 114,
      "verifiedName": "款75镶锆弹簧隔珠"
    },
    "diy-accessory-091.png": {
      "itemId": "ACC-091",
      "styleCategory": "Statement Beads",
      "displayOrder": 115,
      "verifiedName": "款78波浪锆石隔珠"
    },
    "diy-accessory-092.png": {
      "itemId": "ACC-092",
      "styleCategory": "Statement Beads",
      "displayOrder": 116,
      "verifiedName": "款79波纹圆锆石"
    },
    "diy-accessory-094.png": {
      "itemId": "ACC-094",
      "styleCategory": "Statement Beads",
      "displayOrder": 117,
      "verifiedName": "81方锆六角隔珠10mm"
    },
    "diy-accessory-097.png": {
      "itemId": "ACC-097",
      "styleCategory": "Statement Beads",
      "displayOrder": 118,
      "verifiedName": "84四方体四钻隔珠6mm"
    },
    "diy-accessory-104.png": {
      "itemId": "ACC-104",
      "styleCategory": "Statement Beads",
      "displayOrder": 119,
      "verifiedName": "款91镂空锆石隔珠8mm"
    },
    "diy-accessory-109.png": {
      "itemId": "ACC-109",
      "styleCategory": "Statement Beads",
      "displayOrder": 120,
      "verifiedName": "款96 椭圆镶钻4.7mm *8,mm*孔2.2mm"
    },
    "diy-accessory-113.png": {
      "itemId": "ACC-113",
      "styleCategory": "Statement Beads",
      "displayOrder": 121,
      "verifiedName": "款102镶锆石马眼隔珠3.45mm*7.6mm*5mm"
    },
    "diy-accessory-118.png": {
      "itemId": "ACC-118",
      "styleCategory": "Statement Beads",
      "displayOrder": 122,
      "verifiedName": "款108镶锆石隔珠5.6mm*8.8mm*4.9mm"
    },
    "diy-accessory-122.png": {
      "itemId": "ACC-122",
      "styleCategory": "Statement Beads",
      "displayOrder": 123,
      "verifiedName": "款112锆石扭花圈隔珠10mm*10.4*6"
    },
    "diy-accessory-137.png": {
      "itemId": "ACC-137",
      "styleCategory": "Statement Beads",
      "displayOrder": 124,
      "verifiedName": "#1522"
    },
    "diy-accessory-138.png": {
      "itemId": "ACC-138",
      "styleCategory": "Statement Beads",
      "displayOrder": 125,
      "verifiedName": "#1523"
    },
    "diy-accessory-139.png": {
      "itemId": "ACC-139",
      "styleCategory": "Statement Beads",
      "displayOrder": 126,
      "verifiedName": "#1524"
    },
    "diy-accessory-140.png": {
      "itemId": "ACC-140",
      "styleCategory": "Statement Beads",
      "displayOrder": 127,
      "verifiedName": "#1525"
    },
    "diy-accessory-141.png": {
      "itemId": "ACC-141",
      "styleCategory": "Statement Beads",
      "displayOrder": 128,
      "verifiedName": "#1526"
    },
    "diy-accessory-142.png": {
      "itemId": "ACC-142",
      "styleCategory": "Statement Beads",
      "displayOrder": 129,
      "verifiedName": "#1527"
    },
    "diy-accessory-144.png": {
      "itemId": "ACC-144",
      "styleCategory": "Statement Beads",
      "displayOrder": 130,
      "verifiedName": "#1529"
    },
    "diy-accessory-146.png": {
      "itemId": "ACC-146",
      "styleCategory": "Statement Beads",
      "displayOrder": 131,
      "verifiedName": "#1531"
    },
    "diy-accessory-150.png": {
      "itemId": "ACC-150",
      "styleCategory": "Statement Beads",
      "displayOrder": 132,
      "verifiedName": "#1535"
    },
    "diy-accessory-151.png": {
      "itemId": "ACC-151",
      "styleCategory": "Statement Beads",
      "displayOrder": 133,
      "verifiedName": "#1536"
    },
    "diy-accessory-154.png": {
      "itemId": "ACC-154",
      "styleCategory": "Statement Beads",
      "displayOrder": 134,
      "verifiedName": "#1539"
    },
    "diy-accessory-157.png": {
      "itemId": "ACC-157",
      "styleCategory": "Statement Beads",
      "displayOrder": 135,
      "verifiedName": "#1542"
    },
    "diy-accessory-172.png": {
      "itemId": "ACC-172",
      "styleCategory": "Statement Beads",
      "displayOrder": 136,
      "verifiedName": "#1559"
    },
    "diy-accessory-173.png": {
      "itemId": "ACC-173",
      "styleCategory": "Statement Beads",
      "displayOrder": 137,
      "verifiedName": "#1560"
    },
    "diy-accessory-174.png": {
      "itemId": "ACC-174",
      "styleCategory": "Statement Beads",
      "displayOrder": 138,
      "verifiedName": "#1561"
    },
    "diy-accessory-175.png": {
      "itemId": "ACC-175",
      "styleCategory": "Statement Beads",
      "displayOrder": 139,
      "verifiedName": "#1562"
    },
    "diy-accessory-179.png": {
      "itemId": "ACC-179",
      "styleCategory": "Statement Beads",
      "displayOrder": 140,
      "verifiedName": "#1566"
    },
    "diy-accessory-180.png": {
      "itemId": "ACC-180",
      "styleCategory": "Statement Beads",
      "displayOrder": 141,
      "verifiedName": "#1567"
    },
    "diy-accessory-181.png": {
      "itemId": "ACC-181",
      "styleCategory": "Statement Beads",
      "displayOrder": 142,
      "verifiedName": "#1568"
    },
    "diy-accessory-184.png": {
      "itemId": "ACC-184",
      "styleCategory": "Statement Beads",
      "displayOrder": 143,
      "verifiedName": "#1571"
    },
    "diy-accessory-186.png": {
      "itemId": "ACC-186",
      "styleCategory": "Statement Beads",
      "displayOrder": 144,
      "verifiedName": "#1573"
    },
    "diy-accessory-189.png": {
      "itemId": "ACC-189",
      "styleCategory": "Statement Beads",
      "displayOrder": 145,
      "verifiedName": "#1576"
    },
    "diy-accessory-191.png": {
      "itemId": "ACC-191",
      "styleCategory": "Statement Beads",
      "displayOrder": 146,
      "verifiedName": "#1578"
    },
    "diy-accessory-204.png": {
      "itemId": "ACC-204",
      "styleCategory": "Statement Beads",
      "displayOrder": 147,
      "verifiedName": "#1473"
    },
    "diy-accessory-206.png": {
      "itemId": "ACC-206",
      "styleCategory": "Statement Beads",
      "displayOrder": 148,
      "verifiedName": "#1475"
    },
    "diy-accessory-207.png": {
      "itemId": "ACC-207",
      "styleCategory": "Statement Beads",
      "displayOrder": 149,
      "verifiedName": "#1476"
    },
    "diy-accessory-210.png": {
      "itemId": "ACC-210",
      "styleCategory": "Statement Beads",
      "displayOrder": 150,
      "verifiedName": "#1479"
    },
    "diy-accessory-221.png": {
      "itemId": "ACC-221",
      "styleCategory": "Statement Beads",
      "displayOrder": 151,
      "verifiedName": "#686"
    },
    "diy-accessory-222.png": {
      "itemId": "ACC-222",
      "styleCategory": "Statement Beads",
      "displayOrder": 152,
      "verifiedName": "#687"
    },
    "diy-accessory-225.png": {
      "itemId": "ACC-225",
      "styleCategory": "Statement Beads",
      "displayOrder": 153,
      "verifiedName": "#1504"
    },
    "diy-accessory-226.png": {
      "itemId": "ACC-226",
      "styleCategory": "Statement Beads",
      "displayOrder": 154,
      "verifiedName": "#1505"
    },
    "diy-accessory-241.png": {
      "itemId": "ACC-241",
      "styleCategory": "Statement Beads",
      "displayOrder": 155,
      "verifiedName": "#1372"
    },
    "diy-accessory-242.png": {
      "itemId": "ACC-242",
      "styleCategory": "Statement Beads",
      "displayOrder": 156,
      "verifiedName": "#1373"
    },
    "diy-accessory-247.png": {
      "itemId": "ACC-247",
      "styleCategory": "Statement Beads",
      "displayOrder": 157,
      "verifiedName": "#1378"
    },
    "diy-accessory-251.png": {
      "itemId": "ACC-251",
      "styleCategory": "Statement Beads",
      "displayOrder": 158,
      "verifiedName": "#1382"
    },
    "diy-accessory-252.png": {
      "itemId": "ACC-252",
      "styleCategory": "Statement Beads",
      "displayOrder": 159,
      "verifiedName": "#1383"
    },
    "diy-accessory-253.png": {
      "itemId": "ACC-253",
      "styleCategory": "Statement Beads",
      "displayOrder": 160,
      "verifiedName": "#1384"
    },
    "diy-accessory-254.png": {
      "itemId": "ACC-254",
      "styleCategory": "Statement Beads",
      "displayOrder": 161,
      "verifiedName": "#1385"
    },
    "diy-accessory-255.png": {
      "itemId": "ACC-255",
      "styleCategory": "Statement Beads",
      "displayOrder": 162,
      "verifiedName": "#1386"
    },
    "diy-accessory-256.png": {
      "itemId": "ACC-256",
      "styleCategory": "Statement Beads",
      "displayOrder": 163,
      "verifiedName": "#1387"
    },
    "diy-accessory-257.png": {
      "itemId": "ACC-257",
      "styleCategory": "Statement Beads",
      "displayOrder": 164,
      "verifiedName": "#1388"
    },
    "diy-accessory-261.png": {
      "itemId": "ACC-261",
      "styleCategory": "Statement Beads",
      "displayOrder": 165,
      "verifiedName": "#1392"
    },
    "diy-accessory-028.png": {
      "itemId": "ACC-028",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 166,
      "verifiedName": "款15镶锆心形隔珠"
    },
    "diy-accessory-040.png": {
      "itemId": "ACC-040",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 167,
      "verifiedName": "款27镂空花形大孔隔珠"
    },
    "diy-accessory-041.png": {
      "itemId": "ACC-041",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 168,
      "verifiedName": "款28四面玫瑰隔珠"
    },
    "diy-accessory-057.png": {
      "itemId": "ACC-057",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 169,
      "verifiedName": "款44桃心锆石隔珠8mm"
    },
    "diy-accessory-059.png": {
      "itemId": "ACC-059",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 170,
      "verifiedName": "款46双面花托小蛮腰"
    },
    "diy-accessory-069.png": {
      "itemId": "ACC-069",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 171,
      "verifiedName": "款56双排雪花"
    },
    "diy-accessory-070.png": {
      "itemId": "ACC-070",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 172,
      "verifiedName": "款57粉色双排雪花"
    },
    "diy-accessory-072.png": {
      "itemId": "ACC-072",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 173,
      "verifiedName": "款59花朵锆石"
    },
    "diy-accessory-075.png": {
      "itemId": "ACC-075",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 174,
      "verifiedName": "款62双排树叶锆石隔珠9.5mm"
    },
    "diy-accessory-076.png": {
      "itemId": "ACC-076",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 175,
      "verifiedName": "款63镶钻双面小蛮腰花托隔珠"
    },
    "diy-accessory-078.png": {
      "itemId": "ACC-078",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 176,
      "verifiedName": "款65皇冠锆石桶珠"
    },
    "diy-accessory-082.png": {
      "itemId": "ACC-082",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 177,
      "verifiedName": "款69镂空西瓜珠"
    },
    "diy-accessory-083.png": {
      "itemId": "ACC-083",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 178,
      "verifiedName": "款70镂空锆石花球10mm"
    },
    "diy-accessory-089.png": {
      "itemId": "ACC-089",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 179,
      "verifiedName": "款76莲花锆石"
    },
    "diy-accessory-090.png": {
      "itemId": "ACC-090",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 180,
      "verifiedName": "款77镂空锆石"
    },
    "diy-accessory-093.png": {
      "itemId": "ACC-093",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 181,
      "verifiedName": "款80镂空花形大孔隔珠"
    },
    "diy-accessory-095.png": {
      "itemId": "ACC-095",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 182,
      "verifiedName": "82蝴蝶锆石钻圈8.5mm"
    },
    "diy-accessory-107.png": {
      "itemId": "ACC-107",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 183,
      "verifiedName": "款94 玫瑰花隔珠 4.5mm*10mm  孔径6mm"
    },
    "diy-accessory-114.png": {
      "itemId": "ACC-114",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 184,
      "verifiedName": "款103十字架5.6mm*孔1.35mm"
    },
    "diy-accessory-115.png": {
      "itemId": "ACC-115",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 185,
      "verifiedName": "款105镶钻蝴蝶隔珠4.2mm*8.1mm*5.6mm"
    },
    "diy-accessory-116.png": {
      "itemId": "ACC-116",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 186,
      "verifiedName": "款106镶钻钱币大孔隔珠4.3mm*9mm*5.8m"
    },
    "diy-accessory-117.png": {
      "itemId": "ACC-117",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 187,
      "verifiedName": "款107锆石祥云大孔桶珠隔珠5.8mm*7.8mm*3.35mm"
    },
    "diy-accessory-119.png": {
      "itemId": "ACC-119",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 188,
      "verifiedName": "款109耳朵隔珠8mm*9mm*4.1mm"
    },
    "diy-accessory-152.png": {
      "itemId": "ACC-152",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 189,
      "verifiedName": "#1537"
    },
    "diy-accessory-153.png": {
      "itemId": "ACC-153",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 190,
      "verifiedName": "#1538"
    },
    "diy-accessory-158.png": {
      "itemId": "ACC-158",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 191,
      "verifiedName": "#1543"
    },
    "diy-accessory-159.png": {
      "itemId": "ACC-159",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 192,
      "verifiedName": "#1544"
    },
    "diy-accessory-164.png": {
      "itemId": "ACC-164",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 193,
      "verifiedName": "#1549"
    },
    "diy-accessory-165.png": {
      "itemId": "ACC-165",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 194,
      "verifiedName": "#1550"
    },
    "diy-accessory-228.png": {
      "itemId": "ACC-228",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 195,
      "verifiedName": "#1359"
    },
    "diy-accessory-229.png": {
      "itemId": "ACC-229",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 196,
      "verifiedName": "#1360"
    },
    "diy-accessory-232.png": {
      "itemId": "ACC-232",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 197,
      "verifiedName": "#1363"
    },
    "diy-accessory-233.png": {
      "itemId": "ACC-233",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 198,
      "verifiedName": "#1364"
    },
    "diy-accessory-234.png": {
      "itemId": "ACC-234",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 199,
      "verifiedName": "#1365"
    },
    "diy-accessory-235.png": {
      "itemId": "ACC-235",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 200,
      "verifiedName": "#1366"
    },
    "diy-accessory-237.png": {
      "itemId": "ACC-237",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 201,
      "verifiedName": "#1368"
    },
    "diy-accessory-238.png": {
      "itemId": "ACC-238",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 202,
      "verifiedName": "#1369"
    },
    "diy-accessory-248.png": {
      "itemId": "ACC-248",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 203,
      "verifiedName": "#1379"
    },
    "diy-accessory-249.png": {
      "itemId": "ACC-249",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 204,
      "verifiedName": "#1380"
    },
    "diy-accessory-250.png": {
      "itemId": "ACC-250",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 205,
      "verifiedName": "#1381"
    },
    "diy-accessory-262.png": {
      "itemId": "ACC-262",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 206,
      "verifiedName": "#1393"
    },
    "diy-accessory-045.png": {
      "itemId": "ACC-045",
      "styleCategory": "Colour Accents",
      "displayOrder": 207,
      "verifiedName": "款32粉色锆石四方体"
    },
    "diy-accessory-066.png": {
      "itemId": "ACC-066",
      "styleCategory": "Colour Accents",
      "displayOrder": 208,
      "verifiedName": "款53粉色锆石车轮圈"
    },
    "diy-accessory-135.png": {
      "itemId": "ACC-135",
      "styleCategory": "Colour Accents",
      "displayOrder": 209,
      "verifiedName": "#1520"
    },
    "diy-accessory-145.png": {
      "itemId": "ACC-145",
      "styleCategory": "Colour Accents",
      "displayOrder": 210,
      "verifiedName": "#1530"
    },
    "diy-accessory-166.png": {
      "itemId": "ACC-166",
      "styleCategory": "Colour Accents",
      "displayOrder": 211,
      "verifiedName": "#1551"
    },
    "diy-accessory-185.png": {
      "itemId": "ACC-185",
      "styleCategory": "Colour Accents",
      "displayOrder": 212,
      "verifiedName": "#1572"
    },
    "diy-accessory-205.png": {
      "itemId": "ACC-205",
      "styleCategory": "Colour Accents",
      "displayOrder": 213,
      "verifiedName": "#1474"
    }
  },
  "items": [
    {
      "itemId": "ACC-123",
      "category": "Accessories",
      "name": "#1508（硅胶珠）",
      "internalName": "#1508（硅胶珠）",
      "image": "diy-accessory-123.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 63,
      "spacingMm": 2.11
    },
    {
      "itemId": "ACC-124",
      "category": "Accessories",
      "name": "#1509（硅胶珠）",
      "internalName": "#1509（硅胶珠）",
      "image": "diy-accessory-124.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 64,
      "spacingMm": 1.497
    },
    {
      "itemId": "ACC-125",
      "category": "Accessories",
      "name": "#1510（硅胶珠）",
      "internalName": "#1510（硅胶珠）",
      "image": "diy-accessory-125.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 65,
      "spacingMm": 2.756
    },
    {
      "itemId": "ACC-126",
      "category": "Accessories",
      "name": "#1511（硅胶珠）",
      "internalName": "#1511（硅胶珠）",
      "image": "diy-accessory-126.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 66,
      "spacingMm": 3.198
    },
    {
      "itemId": "ACC-127",
      "category": "Accessories",
      "name": "#1512（硅胶珠）",
      "internalName": "#1512（硅胶珠）",
      "image": "diy-accessory-127.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 67,
      "spacingMm": 2.323
    },
    {
      "itemId": "ACC-128",
      "category": "Accessories",
      "name": "#1513（硅胶珠）",
      "internalName": "#1513（硅胶珠）",
      "image": "diy-accessory-128.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 68,
      "spacingMm": 3.509
    },
    {
      "itemId": "ACC-129",
      "category": "Accessories",
      "name": "#1514（硅胶珠）",
      "internalName": "#1514（硅胶珠）",
      "image": "diy-accessory-129.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 69,
      "spacingMm": 2.879
    },
    {
      "itemId": "ACC-130",
      "category": "Accessories",
      "name": "#1515（硅胶珠）",
      "internalName": "#1515（硅胶珠）",
      "image": "diy-accessory-130.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 70,
      "spacingMm": 3.108
    },
    {
      "itemId": "ACC-131",
      "category": "Accessories",
      "name": "#1516（硅胶珠）",
      "internalName": "#1516（硅胶珠）",
      "image": "diy-accessory-131.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 71,
      "spacingMm": 5.161
    },
    {
      "itemId": "ACC-132",
      "category": "Accessories",
      "name": "#1517（硅胶珠）",
      "internalName": "#1517（硅胶珠）",
      "image": "diy-accessory-132.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 72,
      "spacingMm": 4.907
    },
    {
      "itemId": "ACC-133",
      "category": "Accessories",
      "name": "#1518（硅胶珠）",
      "internalName": "#1518（硅胶珠）",
      "image": "diy-accessory-133.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 73,
      "spacingMm": 3.149
    },
    {
      "itemId": "ACC-134",
      "category": "Accessories",
      "name": "#1519（硅胶珠）",
      "internalName": "#1519（硅胶珠）",
      "image": "diy-accessory-134.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Stopper Beads",
      "displayOrder": 74,
      "spacingMm": 5.488
    },
    {
      "itemId": "ACC-034",
      "category": "Accessories",
      "name": "款21锆石圈",
      "internalName": "款21锆石圈",
      "image": "diy-accessory-034.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 75,
      "spacingMm": 2.568
    },
    {
      "itemId": "ACC-046",
      "category": "Accessories",
      "name": "款33齿轮锆石小号8mm",
      "internalName": "款33齿轮锆石小号8mm",
      "image": "diy-accessory-046.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 76,
      "spacingMm": 2.372
    },
    {
      "itemId": "ACC-047",
      "category": "Accessories",
      "name": "款34齿轮锆石大号10mm",
      "internalName": "款34齿轮锆石大号10mm",
      "image": "diy-accessory-047.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 77,
      "spacingMm": 6.02
    },
    {
      "itemId": "ACC-056",
      "category": "Accessories",
      "name": "款43方锆钻圈8mm",
      "internalName": "款43方锆钻圈8mm",
      "image": "diy-accessory-056.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 78,
      "spacingMm": 2.707
    },
    {
      "itemId": "ACC-067",
      "category": "Accessories",
      "name": "款54长方锆石车轮珠",
      "internalName": "款54长方锆石车轮珠",
      "image": "diy-accessory-067.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 79,
      "spacingMm": 6.78
    },
    {
      "itemId": "ACC-074",
      "category": "Accessories",
      "name": "款61车轮三排锆石隔珠",
      "internalName": "款61车轮三排锆石隔珠",
      "image": "diy-accessory-074.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 80,
      "spacingMm": 6.412
    },
    {
      "itemId": "ACC-098",
      "category": "Accessories",
      "name": "85水波槽纹圆形隔珠5mm",
      "internalName": "85水波槽纹圆形隔珠5mm",
      "image": "diy-accessory-098.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 81,
      "spacingMm": 4.466
    },
    {
      "itemId": "ACC-103",
      "category": "Accessories",
      "name": "款90车轮隔片6mm",
      "internalName": "款90车轮隔片6mm",
      "image": "diy-accessory-103.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 82,
      "spacingMm": 3.272
    },
    {
      "itemId": "ACC-112",
      "category": "Accessories",
      "name": "款101车轮隔珠3.3mm*8.1mm*5mm",
      "internalName": "款101车轮隔珠3.3mm*8.1mm*5mm",
      "image": "diy-accessory-112.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 83,
      "spacingMm": 3.018
    },
    {
      "itemId": "ACC-143",
      "category": "Accessories",
      "name": "#1528",
      "internalName": "#1528",
      "image": "diy-accessory-143.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 84,
      "spacingMm": 5.987
    },
    {
      "itemId": "ACC-147",
      "category": "Accessories",
      "name": "#1532",
      "internalName": "#1532",
      "image": "diy-accessory-147.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 85,
      "spacingMm": 1.808
    },
    {
      "itemId": "ACC-148",
      "category": "Accessories",
      "name": "#1533",
      "internalName": "#1533",
      "image": "diy-accessory-148.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 86,
      "spacingMm": 2.274
    },
    {
      "itemId": "ACC-149",
      "category": "Accessories",
      "name": "#1534",
      "internalName": "#1534",
      "image": "diy-accessory-149.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 87,
      "spacingMm": 2.004
    },
    {
      "itemId": "ACC-220",
      "category": "Accessories",
      "name": "#685",
      "internalName": "#685",
      "image": "diy-accessory-220.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 88,
      "spacingMm": 2.421
    },
    {
      "itemId": "ACC-227",
      "category": "Accessories",
      "name": "#1358",
      "internalName": "#1358",
      "image": "diy-accessory-227.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 89,
      "spacingMm": 2.527
    },
    {
      "itemId": "ACC-263",
      "category": "Accessories",
      "name": "#1394",
      "internalName": "#1394",
      "image": "diy-accessory-263.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 90,
      "spacingMm": 3.713
    },
    {
      "itemId": "ACC-264",
      "category": "Accessories",
      "name": "#1395",
      "internalName": "#1395",
      "image": "diy-accessory-264.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Spacer Rings",
      "displayOrder": 91,
      "spacingMm": 3.64
    },
    {
      "itemId": "ACC-032",
      "category": "Accessories",
      "name": "款19微镶方形隔珠",
      "internalName": "款19微镶方形隔珠",
      "image": "diy-accessory-032.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 92,
      "spacingMm": 5.185
    },
    {
      "itemId": "ACC-033",
      "category": "Accessories",
      "name": "款20麻点锆石隔珠",
      "internalName": "款20麻点锆石隔珠",
      "image": "diy-accessory-033.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 93,
      "spacingMm": 4.114
    },
    {
      "itemId": "ACC-042",
      "category": "Accessories",
      "name": "款29四方体锆石隔珠珠4.5*6mm小号",
      "internalName": "款29四方体锆石隔珠珠4.5*6mm小号",
      "image": "diy-accessory-042.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 94,
      "spacingMm": 4.956
    },
    {
      "itemId": "ACC-043",
      "category": "Accessories",
      "name": "款30四方体锆石隔珠珠7*5mm中号",
      "internalName": "款30四方体锆石隔珠珠7*5mm中号",
      "image": "diy-accessory-043.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 95,
      "spacingMm": 5.701
    },
    {
      "itemId": "ACC-044",
      "category": "Accessories",
      "name": "款31四方体锆石隔珠珠6*9mm大号",
      "internalName": "款31四方体锆石隔珠珠6*9mm大号",
      "image": "diy-accessory-044.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 96,
      "spacingMm": 4.793
    },
    {
      "itemId": "ACC-054",
      "category": "Accessories",
      "name": "款41镶蛋形锆大孔隔珠",
      "internalName": "款41镶蛋形锆大孔隔珠",
      "image": "diy-accessory-054.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 97,
      "spacingMm": 5.913
    },
    {
      "itemId": "ACC-055",
      "category": "Accessories",
      "name": "款42纤细六排小蛮腰",
      "internalName": "款42纤细六排小蛮腰",
      "image": "diy-accessory-055.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 98,
      "spacingMm": 7.255
    },
    {
      "itemId": "ACC-058",
      "category": "Accessories",
      "name": "款45圆筒齿轮5.5*6mm",
      "internalName": "款45圆筒齿轮5.5*6mm",
      "image": "diy-accessory-058.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 99,
      "spacingMm": 6.314
    },
    {
      "itemId": "ACC-060",
      "category": "Accessories",
      "name": "款47锆石镂空桶珠小号",
      "internalName": "款47锆石镂空桶珠小号",
      "image": "diy-accessory-060.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 100,
      "spacingMm": 7.893
    },
    {
      "itemId": "ACC-061",
      "category": "Accessories",
      "name": "款48锆石镂空桶珠大号",
      "internalName": "款48锆石镂空桶珠大号",
      "image": "diy-accessory-061.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 101,
      "spacingMm": 7.934
    },
    {
      "itemId": "ACC-062",
      "category": "Accessories",
      "name": "款49锆石小蛮腰小号",
      "internalName": "款49锆石小蛮腰小号",
      "image": "diy-accessory-062.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 102,
      "spacingMm": 6.142
    },
    {
      "itemId": "ACC-063",
      "category": "Accessories",
      "name": "款50锆石小蛮腰大号",
      "internalName": "款50锆石小蛮腰大号",
      "image": "diy-accessory-063.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 103,
      "spacingMm": 7.287
    },
    {
      "itemId": "ACC-064",
      "category": "Accessories",
      "name": "款51圆柱锆石",
      "internalName": "款51圆柱锆石",
      "image": "diy-accessory-064.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 104,
      "spacingMm": 6.437
    },
    {
      "itemId": "ACC-065",
      "category": "Accessories",
      "name": "款52石路路通隔珠",
      "internalName": "款52石路路通隔珠",
      "image": "diy-accessory-065.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 105,
      "spacingMm": 6.126
    },
    {
      "itemId": "ACC-068",
      "category": "Accessories",
      "name": "款55金边小蛮腰",
      "internalName": "款55金边小蛮腰",
      "image": "diy-accessory-068.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 106,
      "spacingMm": 7.018
    },
    {
      "itemId": "ACC-071",
      "category": "Accessories",
      "name": "款58镶锆齿轮隔珠",
      "internalName": "款58镶锆齿轮隔珠",
      "image": "diy-accessory-071.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 107,
      "spacingMm": 3.73
    },
    {
      "itemId": "ACC-073",
      "category": "Accessories",
      "name": "款60大孔锆石隔珠",
      "internalName": "款60大孔锆石隔珠",
      "image": "diy-accessory-073.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 108,
      "spacingMm": 6.29
    },
    {
      "itemId": "ACC-077",
      "category": "Accessories",
      "name": "款64小蛮腰锆石隔珠8*10mm",
      "internalName": "款64小蛮腰锆石隔珠8*10mm",
      "image": "diy-accessory-077.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 109,
      "spacingMm": 7.492
    },
    {
      "itemId": "ACC-080",
      "category": "Accessories",
      "name": "款67镂空锆石球",
      "internalName": "款67镂空锆石球",
      "image": "diy-accessory-080.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 110,
      "spacingMm": 6.551
    },
    {
      "itemId": "ACC-081",
      "category": "Accessories",
      "name": "款68镶钻圆球8mm",
      "internalName": "款68镶钻圆球8mm",
      "image": "diy-accessory-081.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 111,
      "spacingMm": 6.805
    },
    {
      "itemId": "ACC-084",
      "category": "Accessories",
      "name": "款71镂空锆石隔珠",
      "internalName": "款71镂空锆石隔珠",
      "image": "diy-accessory-084.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 112,
      "spacingMm": 7.925
    },
    {
      "itemId": "ACC-085",
      "category": "Accessories",
      "name": "款72镂空锆石绣球10mm",
      "internalName": "款72镂空锆石绣球10mm",
      "image": "diy-accessory-085.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 113,
      "spacingMm": 7.026
    },
    {
      "itemId": "ACC-088",
      "category": "Accessories",
      "name": "款75镶锆弹簧隔珠",
      "internalName": "款75镶锆弹簧隔珠",
      "image": "diy-accessory-088.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 114,
      "spacingMm": 6.478
    },
    {
      "itemId": "ACC-091",
      "category": "Accessories",
      "name": "款78波浪锆石隔珠",
      "internalName": "款78波浪锆石隔珠",
      "image": "diy-accessory-091.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 115,
      "spacingMm": 6.273
    },
    {
      "itemId": "ACC-092",
      "category": "Accessories",
      "name": "款79波纹圆锆石",
      "internalName": "款79波纹圆锆石",
      "image": "diy-accessory-092.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 116,
      "spacingMm": 3.95
    },
    {
      "itemId": "ACC-094",
      "category": "Accessories",
      "name": "81方锆六角隔珠10mm",
      "internalName": "81方锆六角隔珠10mm",
      "image": "diy-accessory-094.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 117,
      "spacingMm": 3.697
    },
    {
      "itemId": "ACC-097",
      "category": "Accessories",
      "name": "84四方体四钻隔珠6mm",
      "internalName": "84四方体四钻隔珠6mm",
      "image": "diy-accessory-097.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 118,
      "spacingMm": 6.838
    },
    {
      "itemId": "ACC-104",
      "category": "Accessories",
      "name": "款91镂空锆石隔珠8mm",
      "internalName": "款91镂空锆石隔珠8mm",
      "image": "diy-accessory-104.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 119,
      "spacingMm": 6.748
    },
    {
      "itemId": "ACC-109",
      "category": "Accessories",
      "name": "款96 椭圆镶钻4.7mm *8,mm*孔2.2mm",
      "internalName": "款96 椭圆镶钻4.7mm *8,mm*孔2.2mm",
      "image": "diy-accessory-109.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 120,
      "spacingMm": 4.351
    },
    {
      "itemId": "ACC-113",
      "category": "Accessories",
      "name": "款102镶锆石马眼隔珠3.45mm*7.6mm*5mm",
      "internalName": "款102镶锆石马眼隔珠3.45mm*7.6mm*5mm",
      "image": "diy-accessory-113.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 121,
      "spacingMm": 2.854
    },
    {
      "itemId": "ACC-118",
      "category": "Accessories",
      "name": "款108镶锆石隔珠5.6mm*8.8mm*4.9mm",
      "internalName": "款108镶锆石隔珠5.6mm*8.8mm*4.9mm",
      "image": "diy-accessory-118.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 122,
      "spacingMm": 4.392
    },
    {
      "itemId": "ACC-122",
      "category": "Accessories",
      "name": "款112锆石扭花圈隔珠10mm*10.4*6",
      "internalName": "款112锆石扭花圈隔珠10mm*10.4*6",
      "image": "diy-accessory-122.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 123,
      "spacingMm": 7.263
    },
    {
      "itemId": "ACC-137",
      "category": "Accessories",
      "name": "#1522",
      "internalName": "#1522",
      "image": "diy-accessory-137.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 124,
      "spacingMm": 3.713
    },
    {
      "itemId": "ACC-138",
      "category": "Accessories",
      "name": "#1523",
      "internalName": "#1523",
      "image": "diy-accessory-138.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 125,
      "spacingMm": 3.86
    },
    {
      "itemId": "ACC-139",
      "category": "Accessories",
      "name": "#1524",
      "internalName": "#1524",
      "image": "diy-accessory-139.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 126,
      "spacingMm": 5.145
    },
    {
      "itemId": "ACC-140",
      "category": "Accessories",
      "name": "#1525",
      "internalName": "#1525",
      "image": "diy-accessory-140.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 127,
      "spacingMm": 3.64
    },
    {
      "itemId": "ACC-141",
      "category": "Accessories",
      "name": "#1526",
      "internalName": "#1526",
      "image": "diy-accessory-141.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 128,
      "spacingMm": 3.983
    },
    {
      "itemId": "ACC-142",
      "category": "Accessories",
      "name": "#1527",
      "internalName": "#1527",
      "image": "diy-accessory-142.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 129,
      "spacingMm": 3.885
    },
    {
      "itemId": "ACC-144",
      "category": "Accessories",
      "name": "#1529",
      "internalName": "#1529",
      "image": "diy-accessory-144.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 130,
      "spacingMm": 1.489
    },
    {
      "itemId": "ACC-146",
      "category": "Accessories",
      "name": "#1531",
      "internalName": "#1531",
      "image": "diy-accessory-146.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 131,
      "spacingMm": 1.734
    },
    {
      "itemId": "ACC-150",
      "category": "Accessories",
      "name": "#1535",
      "internalName": "#1535",
      "image": "diy-accessory-150.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 132,
      "spacingMm": 5.84
    },
    {
      "itemId": "ACC-151",
      "category": "Accessories",
      "name": "#1536",
      "internalName": "#1536",
      "image": "diy-accessory-151.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 133,
      "spacingMm": 5.832
    },
    {
      "itemId": "ACC-154",
      "category": "Accessories",
      "name": "#1539",
      "internalName": "#1539",
      "image": "diy-accessory-154.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 134,
      "spacingMm": 7.238
    },
    {
      "itemId": "ACC-157",
      "category": "Accessories",
      "name": "#1542",
      "internalName": "#1542",
      "image": "diy-accessory-157.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 135,
      "spacingMm": 8.138
    },
    {
      "itemId": "ACC-172",
      "category": "Accessories",
      "name": "#1559",
      "internalName": "#1559",
      "image": "diy-accessory-172.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 136,
      "spacingMm": 6.11
    },
    {
      "itemId": "ACC-173",
      "category": "Accessories",
      "name": "#1560",
      "internalName": "#1560",
      "image": "diy-accessory-173.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 137,
      "spacingMm": 5.823
    },
    {
      "itemId": "ACC-174",
      "category": "Accessories",
      "name": "#1561",
      "internalName": "#1561",
      "image": "diy-accessory-174.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 138,
      "spacingMm": 6.838
    },
    {
      "itemId": "ACC-175",
      "category": "Accessories",
      "name": "#1562",
      "internalName": "#1562",
      "image": "diy-accessory-175.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 139,
      "spacingMm": 5.971
    },
    {
      "itemId": "ACC-179",
      "category": "Accessories",
      "name": "#1566",
      "internalName": "#1566",
      "image": "diy-accessory-179.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 140,
      "spacingMm": 8.048
    },
    {
      "itemId": "ACC-180",
      "category": "Accessories",
      "name": "#1567",
      "internalName": "#1567",
      "image": "diy-accessory-180.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 141,
      "spacingMm": 6.167
    },
    {
      "itemId": "ACC-181",
      "category": "Accessories",
      "name": "#1568",
      "internalName": "#1568",
      "image": "diy-accessory-181.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 142,
      "spacingMm": 7.598
    },
    {
      "itemId": "ACC-184",
      "category": "Accessories",
      "name": "#1571",
      "internalName": "#1571",
      "image": "diy-accessory-184.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 143,
      "spacingMm": 6.993
    },
    {
      "itemId": "ACC-186",
      "category": "Accessories",
      "name": "#1573",
      "internalName": "#1573",
      "image": "diy-accessory-186.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 144,
      "spacingMm": 7.525
    },
    {
      "itemId": "ACC-189",
      "category": "Accessories",
      "name": "#1576",
      "internalName": "#1576",
      "image": "diy-accessory-189.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 145,
      "spacingMm": 8.392
    },
    {
      "itemId": "ACC-191",
      "category": "Accessories",
      "name": "#1578",
      "internalName": "#1578",
      "image": "diy-accessory-191.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 146,
      "spacingMm": 8.858
    },
    {
      "itemId": "ACC-204",
      "category": "Accessories",
      "name": "#1473",
      "internalName": "#1473",
      "image": "diy-accessory-204.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 147,
      "spacingMm": 6.993
    },
    {
      "itemId": "ACC-206",
      "category": "Accessories",
      "name": "#1475",
      "internalName": "#1475",
      "image": "diy-accessory-206.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 148,
      "spacingMm": 6.658
    },
    {
      "itemId": "ACC-207",
      "category": "Accessories",
      "name": "#1476",
      "internalName": "#1476",
      "image": "diy-accessory-207.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 149,
      "spacingMm": 6.347
    },
    {
      "itemId": "ACC-210",
      "category": "Accessories",
      "name": "#1479",
      "internalName": "#1479",
      "image": "diy-accessory-210.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 150,
      "spacingMm": 6.543
    },
    {
      "itemId": "ACC-221",
      "category": "Accessories",
      "name": "#686",
      "internalName": "#686",
      "image": "diy-accessory-221.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 151,
      "spacingMm": 2.364
    },
    {
      "itemId": "ACC-222",
      "category": "Accessories",
      "name": "#687",
      "internalName": "#687",
      "image": "diy-accessory-222.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 152,
      "spacingMm": 2.478
    },
    {
      "itemId": "ACC-225",
      "category": "Accessories",
      "name": "#1504",
      "internalName": "#1504",
      "image": "diy-accessory-225.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 153,
      "spacingMm": 5.504
    },
    {
      "itemId": "ACC-226",
      "category": "Accessories",
      "name": "#1505",
      "internalName": "#1505",
      "image": "diy-accessory-226.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 154,
      "spacingMm": 5.095
    },
    {
      "itemId": "ACC-241",
      "category": "Accessories",
      "name": "#1372",
      "internalName": "#1372",
      "image": "diy-accessory-241.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 155,
      "spacingMm": 5.12
    },
    {
      "itemId": "ACC-242",
      "category": "Accessories",
      "name": "#1373",
      "internalName": "#1373",
      "image": "diy-accessory-242.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 156,
      "spacingMm": 6.846
    },
    {
      "itemId": "ACC-247",
      "category": "Accessories",
      "name": "#1378",
      "internalName": "#1378",
      "image": "diy-accessory-247.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 157,
      "spacingMm": 5.57
    },
    {
      "itemId": "ACC-251",
      "category": "Accessories",
      "name": "#1382",
      "internalName": "#1382",
      "image": "diy-accessory-251.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 158,
      "spacingMm": 6.404
    },
    {
      "itemId": "ACC-252",
      "category": "Accessories",
      "name": "#1383",
      "internalName": "#1383",
      "image": "diy-accessory-252.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 159,
      "spacingMm": 6.69
    },
    {
      "itemId": "ACC-253",
      "category": "Accessories",
      "name": "#1384",
      "internalName": "#1384",
      "image": "diy-accessory-253.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 160,
      "spacingMm": 3.362
    },
    {
      "itemId": "ACC-254",
      "category": "Accessories",
      "name": "#1385",
      "internalName": "#1385",
      "image": "diy-accessory-254.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 161,
      "spacingMm": 5.169
    },
    {
      "itemId": "ACC-255",
      "category": "Accessories",
      "name": "#1386",
      "internalName": "#1386",
      "image": "diy-accessory-255.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 162,
      "spacingMm": 1.08
    },
    {
      "itemId": "ACC-256",
      "category": "Accessories",
      "name": "#1387",
      "internalName": "#1387",
      "image": "diy-accessory-256.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 163,
      "spacingMm": 0.949
    },
    {
      "itemId": "ACC-257",
      "category": "Accessories",
      "name": "#1388",
      "internalName": "#1388",
      "image": "diy-accessory-257.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 164,
      "spacingMm": 7.426
    },
    {
      "itemId": "ACC-261",
      "category": "Accessories",
      "name": "#1392",
      "internalName": "#1392",
      "image": "diy-accessory-261.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Statement Beads",
      "displayOrder": 165,
      "spacingMm": 1.791
    },
    {
      "itemId": "ACC-028",
      "category": "Accessories",
      "name": "款15镶锆心形隔珠",
      "internalName": "款15镶锆心形隔珠",
      "image": "diy-accessory-028.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 166,
      "spacingMm": 2.789
    },
    {
      "itemId": "ACC-040",
      "category": "Accessories",
      "name": "款27镂空花形大孔隔珠",
      "internalName": "款27镂空花形大孔隔珠",
      "image": "diy-accessory-040.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 167,
      "spacingMm": 3.803
    },
    {
      "itemId": "ACC-041",
      "category": "Accessories",
      "name": "款28四面玫瑰隔珠",
      "internalName": "款28四面玫瑰隔珠",
      "image": "diy-accessory-041.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 168,
      "spacingMm": 5.414
    },
    {
      "itemId": "ACC-057",
      "category": "Accessories",
      "name": "款44桃心锆石隔珠8mm",
      "internalName": "款44桃心锆石隔珠8mm",
      "image": "diy-accessory-057.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 169,
      "spacingMm": 6.224
    },
    {
      "itemId": "ACC-059",
      "category": "Accessories",
      "name": "款46双面花托小蛮腰",
      "internalName": "款46双面花托小蛮腰",
      "image": "diy-accessory-059.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 170,
      "spacingMm": 6.756
    },
    {
      "itemId": "ACC-069",
      "category": "Accessories",
      "name": "款56双排雪花",
      "internalName": "款56双排雪花",
      "image": "diy-accessory-069.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 171,
      "spacingMm": 4.286
    },
    {
      "itemId": "ACC-070",
      "category": "Accessories",
      "name": "款57粉色双排雪花",
      "internalName": "款57粉色双排雪花",
      "image": "diy-accessory-070.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 172,
      "spacingMm": 6.928
    },
    {
      "itemId": "ACC-072",
      "category": "Accessories",
      "name": "款59花朵锆石",
      "internalName": "款59花朵锆石",
      "image": "diy-accessory-072.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 173,
      "spacingMm": 4.302
    },
    {
      "itemId": "ACC-075",
      "category": "Accessories",
      "name": "款62双排树叶锆石隔珠9.5mm",
      "internalName": "款62双排树叶锆石隔珠9.5mm",
      "image": "diy-accessory-075.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 174,
      "spacingMm": 8.408
    },
    {
      "itemId": "ACC-076",
      "category": "Accessories",
      "name": "款63镶钻双面小蛮腰花托隔珠",
      "internalName": "款63镶钻双面小蛮腰花托隔珠",
      "image": "diy-accessory-076.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 175,
      "spacingMm": 7.696
    },
    {
      "itemId": "ACC-078",
      "category": "Accessories",
      "name": "款65皇冠锆石桶珠",
      "internalName": "款65皇冠锆石桶珠",
      "image": "diy-accessory-078.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 176,
      "spacingMm": 7.582
    },
    {
      "itemId": "ACC-082",
      "category": "Accessories",
      "name": "款69镂空西瓜珠",
      "internalName": "款69镂空西瓜珠",
      "image": "diy-accessory-082.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 177,
      "spacingMm": 7.672
    },
    {
      "itemId": "ACC-083",
      "category": "Accessories",
      "name": "款70镂空锆石花球10mm",
      "internalName": "款70镂空锆石花球10mm",
      "image": "diy-accessory-083.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 178,
      "spacingMm": 7.876
    },
    {
      "itemId": "ACC-089",
      "category": "Accessories",
      "name": "款76莲花锆石",
      "internalName": "款76莲花锆石",
      "image": "diy-accessory-089.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 179,
      "spacingMm": 6.077
    },
    {
      "itemId": "ACC-090",
      "category": "Accessories",
      "name": "款77镂空锆石",
      "internalName": "款77镂空锆石",
      "image": "diy-accessory-090.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 180,
      "spacingMm": 5.267
    },
    {
      "itemId": "ACC-093",
      "category": "Accessories",
      "name": "款80镂空花形大孔隔珠",
      "internalName": "款80镂空花形大孔隔珠",
      "image": "diy-accessory-093.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 181,
      "spacingMm": 5.136
    },
    {
      "itemId": "ACC-095",
      "category": "Accessories",
      "name": "82蝴蝶锆石钻圈8.5mm",
      "internalName": "82蝴蝶锆石钻圈8.5mm",
      "image": "diy-accessory-095.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 182,
      "spacingMm": 5.169
    },
    {
      "itemId": "ACC-107",
      "category": "Accessories",
      "name": "款94 玫瑰花隔珠 4.5mm*10mm  孔径6mm",
      "internalName": "款94 玫瑰花隔珠 4.5mm*10mm  孔径6mm",
      "image": "diy-accessory-107.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 183,
      "spacingMm": 3.558
    },
    {
      "itemId": "ACC-114",
      "category": "Accessories",
      "name": "款103十字架5.6mm*孔1.35mm",
      "internalName": "款103十字架5.6mm*孔1.35mm",
      "image": "diy-accessory-114.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 184,
      "spacingMm": 7.639
    },
    {
      "itemId": "ACC-115",
      "category": "Accessories",
      "name": "款105镶钻蝴蝶隔珠4.2mm*8.1mm*5.6mm",
      "internalName": "款105镶钻蝴蝶隔珠4.2mm*8.1mm*5.6mm",
      "image": "diy-accessory-115.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 185,
      "spacingMm": 3.37
    },
    {
      "itemId": "ACC-116",
      "category": "Accessories",
      "name": "款106镶钻钱币大孔隔珠4.3mm*9mm*5.8m",
      "internalName": "款106镶钻钱币大孔隔珠4.3mm*9mm*5.8m",
      "image": "diy-accessory-116.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 186,
      "spacingMm": 3.468
    },
    {
      "itemId": "ACC-117",
      "category": "Accessories",
      "name": "款107锆石祥云大孔桶珠隔珠5.8mm*7.8mm*3.35mm",
      "internalName": "款107锆石祥云大孔桶珠隔珠5.8mm*7.8mm*3.35mm",
      "image": "diy-accessory-117.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 187,
      "spacingMm": 6.478
    },
    {
      "itemId": "ACC-119",
      "category": "Accessories",
      "name": "款109耳朵隔珠8mm*9mm*4.1mm",
      "internalName": "款109耳朵隔珠8mm*9mm*4.1mm",
      "image": "diy-accessory-119.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 188,
      "spacingMm": 6.739
    },
    {
      "itemId": "ACC-152",
      "category": "Accessories",
      "name": "#1537",
      "internalName": "#1537",
      "image": "diy-accessory-152.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 189,
      "spacingMm": 4.858
    },
    {
      "itemId": "ACC-153",
      "category": "Accessories",
      "name": "#1538",
      "internalName": "#1538",
      "image": "diy-accessory-153.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 190,
      "spacingMm": 6.02
    },
    {
      "itemId": "ACC-158",
      "category": "Accessories",
      "name": "#1543",
      "internalName": "#1543",
      "image": "diy-accessory-158.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 191,
      "spacingMm": 7.95
    },
    {
      "itemId": "ACC-159",
      "category": "Accessories",
      "name": "#1544",
      "internalName": "#1544",
      "image": "diy-accessory-159.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 192,
      "spacingMm": 7.991
    },
    {
      "itemId": "ACC-164",
      "category": "Accessories",
      "name": "#1549",
      "internalName": "#1549",
      "image": "diy-accessory-164.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 193,
      "spacingMm": 5.864
    },
    {
      "itemId": "ACC-165",
      "category": "Accessories",
      "name": "#1550",
      "internalName": "#1550",
      "image": "diy-accessory-165.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 194,
      "spacingMm": 6.682
    },
    {
      "itemId": "ACC-228",
      "category": "Accessories",
      "name": "#1359",
      "internalName": "#1359",
      "image": "diy-accessory-228.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 195,
      "spacingMm": 6.829
    },
    {
      "itemId": "ACC-229",
      "category": "Accessories",
      "name": "#1360",
      "internalName": "#1360",
      "image": "diy-accessory-229.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 196,
      "spacingMm": 7.173
    },
    {
      "itemId": "ACC-232",
      "category": "Accessories",
      "name": "#1363",
      "internalName": "#1363",
      "image": "diy-accessory-232.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 197,
      "spacingMm": 6.388
    },
    {
      "itemId": "ACC-233",
      "category": "Accessories",
      "name": "#1364",
      "internalName": "#1364",
      "image": "diy-accessory-233.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 198,
      "spacingMm": 7.345
    },
    {
      "itemId": "ACC-234",
      "category": "Accessories",
      "name": "#1365",
      "internalName": "#1365",
      "image": "diy-accessory-234.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 199,
      "spacingMm": 6.846
    },
    {
      "itemId": "ACC-235",
      "category": "Accessories",
      "name": "#1366",
      "internalName": "#1366",
      "image": "diy-accessory-235.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 200,
      "spacingMm": 5.766
    },
    {
      "itemId": "ACC-237",
      "category": "Accessories",
      "name": "#1368",
      "internalName": "#1368",
      "image": "diy-accessory-237.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 201,
      "spacingMm": 2.552
    },
    {
      "itemId": "ACC-238",
      "category": "Accessories",
      "name": "#1369",
      "internalName": "#1369",
      "image": "diy-accessory-238.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 202,
      "spacingMm": 1.718
    },
    {
      "itemId": "ACC-248",
      "category": "Accessories",
      "name": "#1379",
      "internalName": "#1379",
      "image": "diy-accessory-248.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 203,
      "spacingMm": 6.658
    },
    {
      "itemId": "ACC-249",
      "category": "Accessories",
      "name": "#1380",
      "internalName": "#1380",
      "image": "diy-accessory-249.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 204,
      "spacingMm": 6.502
    },
    {
      "itemId": "ACC-250",
      "category": "Accessories",
      "name": "#1381",
      "internalName": "#1381",
      "image": "diy-accessory-250.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 205,
      "spacingMm": 3.738
    },
    {
      "itemId": "ACC-262",
      "category": "Accessories",
      "name": "#1393",
      "internalName": "#1393",
      "image": "diy-accessory-262.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Floral & Symbols",
      "displayOrder": 206,
      "spacingMm": 8.089
    },
    {
      "itemId": "ACC-045",
      "category": "Accessories",
      "name": "款32粉色锆石四方体",
      "internalName": "款32粉色锆石四方体",
      "image": "diy-accessory-045.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Colour Accents",
      "displayOrder": 207,
      "spacingMm": 6.191
    },
    {
      "itemId": "ACC-066",
      "category": "Accessories",
      "name": "款53粉色锆石车轮圈",
      "internalName": "款53粉色锆石车轮圈",
      "image": "diy-accessory-066.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Colour Accents",
      "displayOrder": 208,
      "spacingMm": 3.304
    },
    {
      "itemId": "ACC-135",
      "category": "Accessories",
      "name": "#1520",
      "internalName": "#1520",
      "image": "diy-accessory-135.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Colour Accents",
      "displayOrder": 209,
      "spacingMm": 3.394
    },
    {
      "itemId": "ACC-145",
      "category": "Accessories",
      "name": "#1530",
      "internalName": "#1530",
      "image": "diy-accessory-145.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Colour Accents",
      "displayOrder": 210,
      "spacingMm": 2.446
    },
    {
      "itemId": "ACC-166",
      "category": "Accessories",
      "name": "#1551",
      "internalName": "#1551",
      "image": "diy-accessory-166.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Colour Accents",
      "displayOrder": 211,
      "spacingMm": 6.363
    },
    {
      "itemId": "ACC-185",
      "category": "Accessories",
      "name": "#1572",
      "internalName": "#1572",
      "image": "diy-accessory-185.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Colour Accents",
      "displayOrder": 212,
      "spacingMm": 5.962
    },
    {
      "itemId": "ACC-205",
      "category": "Accessories",
      "name": "#1474",
      "internalName": "#1474",
      "image": "diy-accessory-205.png",
      "sizes": [
        8
      ],
      "price": 0,
      "kind": "component",
      "styleCategory": "Colour Accents",
      "displayOrder": 213,
      "spacingMm": 6.478
    }
  ]
};
